import { GlobalController } from 'src/shared/global/GlobalController'
import RouteDetailing from './RouteDetailing'
const ifAuthenticated = (to, from, next) => {
  GlobalController.getAsyncInstance().then(data => {
    if (data && data.authResp && data.authResp.token) {
      next()
    } else {
      next('/')
    }
  })
}
export const routes = [
  {
    path: 'route-detailing',
    name:
      'routeDetailing',
    component: RouteDetailing,
    beforeEnter: ifAuthenticated,
    props: true
  }
]
